/* =============================================
   Marché Collage : vague 2 des maquettes par type de page, lot E (28/09/2026), pages d'aide
   Q5 : FAQ, le champ « Chercher une réponse » (snippets/nkosi-mc-faq-tete.liquid) filtre les questions pendant la
        frappe (intitulé et réponse, sans tenir compte des accents) ; les rubriques vides se cachent, les questions
        trouvées s'ouvrent ; le nombre de réponses est annoncé ; sans résultat, lien « Nous écrire ».
   V1 : avis (snippets/nkosi-mc-avis.liquid), chaque barre de la répartition actionne le filtre par note de Judge.me,
        « Toutes les notes » l'efface ; « Donner mon avis » ouvre le formulaire de Judge.me ; « Lire l'avis entier »
        passe à l'onglet des avis sur la boutique et amène l'avis ; le tri de Judge.me reçoit un libellé visible.
   T1 : contact, après l'envoi (ou une erreur), le message de confirmation prend le focus.
   Sans ces blocs dans la page, rien ne se passe.
   ============================================= */
(function () {
  'use strict';

  /* ---------- Q5 : recherche dans la FAQ ---------- */
  var champ = document.getElementById('nk-v2-faq-champ');
  if (champ) {
    var racine = champ.closest('.nk-mc-faq') || document;
    var etat = racine.querySelector('.nk-v2-faq-recherche__etat');
    var ecrire = racine.querySelector('.nk-v2-faq-recherche__ecrire');
    var sommaire = racine.querySelector('.nk-mc-faq__sommaire');
    var plat = function (s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ');
    };
    var questions = Array.prototype.map.call(racine.querySelectorAll('.nk-mc-faq__question'), function (d) {
      return { el: d, texte: plat(d.textContent), ouvert: d.open };
    });
    var rubriques = racine.querySelectorAll('.nk-mc-faq__rubrique');
    var filtrer = function () {
      var mots = plat(champ.value).trim().split(' ').filter(function (m) { return m.length > 1; });
      var n = 0;
      questions.forEach(function (q) {
        var ok = !mots.length || mots.every(function (m) { return q.texte.indexOf(m) >= 0; });
        q.el.hidden = !ok;
        if (ok) n++;
        q.el.open = mots.length ? ok : q.ouvert;
      });
      Array.prototype.forEach.call(rubriques, function (r) {
        r.hidden = !!mots.length && !r.querySelector('.nk-mc-faq__question:not([hidden])');
      });
      if (sommaire) sommaire.parentNode.hidden = !!mots.length;
      if (!mots.length) { etat.textContent = ''; if (ecrire) ecrire.hidden = true; return; }
      etat.textContent = n === 0 ? champ.getAttribute('data-aucune') :
        (n === 1 ? champ.getAttribute('data-un') : champ.getAttribute('data-plusieurs').replace('{n}', n));
      if (ecrire) ecrire.hidden = n !== 0;
    };
    var minuteur = null;
    champ.addEventListener('input', function () { clearTimeout(minuteur); minuteur = setTimeout(filtrer, 120); });
    champ.addEventListener('search', filtrer);
  }

  /* ---------- V1 : page des avis ---------- */
  var avis = document.querySelector('[data-nk-v2-avis]');
  if (avis) {
    var widget = function () { return document.querySelector('.jdgm-all-reviews-widget'); };
    var quandPret = function (fn, essais) {
      var w = widget();
      if (w && w.classList.contains('jdgm--done-setup-widget')) { fn(w); return; }
      if ((essais || 0) > 50) { if (w) fn(w); return; }
      setTimeout(function () { quandPret(fn, (essais || 0) + 1); }, 200);
    };
    var amener = function (el) {
      if (!el) return;
      var haut = el.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: Math.max(0, haut), behavior: 'smooth' });
    };
    var barres = avis.querySelectorAll('[data-nk-v2-note]');
    avis.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-nk-v2-note], [data-nk-v2-donner], [data-nk-v2-lire]');
      if (!b) return;
      if (b.hasAttribute('data-nk-v2-note')) {
        var note = b.getAttribute('data-nk-v2-note');
        var deja = b.getAttribute('aria-pressed') === 'true';
        if (deja && note !== 'toutes') note = 'toutes';
        quandPret(function (w) {
          var cible = note === 'toutes' ?
            w.querySelector('.jdgm-histogram__clear-filter') :
            w.querySelector('.jdgm-histogram__row[data-rating="' + note + '"] .jdgm-histogram__star');
          if (cible) cible.click();
          Array.prototype.forEach.call(barres, function (x) {
            x.setAttribute('aria-pressed', x.getAttribute('data-nk-v2-note') === note ? 'true' : 'false');
          });
          amener(w.querySelector('.jdgm-rev-widg__actions') || w);
        });
      } else if (b.hasAttribute('data-nk-v2-donner')) {
        /* Judge.me construit le formulaire au premier clic sur son lien (caché), l'affiche au suivant et le referme au
           troisième : ici, un seul appui l'ouvre, et un formulaire déjà ouvert n'est jamais refermé */
        quandPret(function (w) {
          var lien = w.querySelector('.jdgm-write-rev-link');
          var ouvert = function () { var f = w.querySelector('.jdgm-form-wrapper'); return f && f.offsetHeight > 0 ? f : null; };
          if (ouvert()) { amener(ouvert()); return; }
          if (!lien) return;
          lien.click();
          var essais = 0, relance = false;
          (function voir() {
            var f = w.querySelector('.jdgm-form-wrapper');
            if (ouvert()) { amener(ouvert()); return; }
            if (f && !relance && essais >= 1) { relance = true; lien.click(); }
            if (essais++ < 20) setTimeout(voir, 200);
          })();
        });
      } else {
        var id = b.getAttribute('data-nk-v2-lire');
        quandPret(function (w) {
          var tout = w.querySelector('.jdgm-histogram__clear-filter');
          if (tout) tout.click();
          Array.prototype.forEach.call(barres, function (x) {
            x.setAttribute('aria-pressed', x.getAttribute('data-nk-v2-note') === 'toutes' ? 'true' : 'false');
          });
          var onglet = w.querySelector('.jdgm-subtab__name[data-tabname="shop-reviews"]');
          if (onglet && !onglet.classList.contains('jdgm--active')) onglet.click();
          var essais = 0;
          (function chercher() {
            var r = w.querySelector('.jdgm-rev[data-review-id="' + id + '"]');
            if (r || essais++ > 25) { amener(r || w); return; }
            setTimeout(chercher, 200);
          })();
        });
      }
    });
    /* tri : le libellé de Judge.me est caché (et en anglais) ; la loi demande d'afficher le critère de classement */
    var tri = avis.getAttribute('data-tri');
    var majTri = function (w) {
      Array.prototype.forEach.call(w.querySelectorAll('.jdgm-sort-dropdown-label'), function (lib) {
        if (lib.textContent !== tri) lib.textContent = tri;
        if (!lib.classList.contains('nk-v2-tri-visible')) lib.classList.add('nk-v2-tri-visible');
      });
    };
    quandPret(function (w) {
      majTri(w);
      if (!window.MutationObserver) return;
      var attente = null;
      new MutationObserver(function () { clearTimeout(attente); attente = setTimeout(function () { majTri(w); }, 150); })
        .observe(w, { childList: true, subtree: true });
    });
  }

  /* ---------- T1 : contact, message après l'envoi ---------- */
  var retour = document.getElementById('ContactForm-merci') || document.getElementById('ContactForm-alerte');
  if (retour) {
    try { retour.focus({ preventScroll: true }); } catch (e) { retour.focus(); }
    var haut = retour.getBoundingClientRect().top + window.pageYOffset - 140;
    window.scrollTo(0, Math.max(0, haut));
  }
})();
/* fin du lot E de la vague 2 */
